import { render, staticRenderFns } from "./uppy_user_avatar.vue?vue&type=template&id=623f9435&scoped=true"
import script from "./uppy_user_avatar.vue?vue&type=script&lang=js"
export * from "./uppy_user_avatar.vue?vue&type=script&lang=js"
import style0 from "./uppy_user_avatar.vue?vue&type=style&index=0&id=623f9435&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f9435",
  null
  
)

export default component.exports